// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3fkcP","errors":"Errors_errors__38QjG"};